import React from "react";
import TagLayout from "Layouts/TagLayout";
import { TagButton } from "ComponentsUI/Buttons";
import { v4 } from "uuid";

const TagButtonComponent = (props) => {
	let {
		mobileTags,
		tagCode,
		operatorRates,
		operatorBeautifulNumbers,
		ratesMobile,
		beautifulNumbers,
		providerInetTvMobile,
		providerInetMobile,
		operatorStyle,
	} = props;
	return (
		<TagLayout>
			<TagButton
				key={v4()}
				active={!tagCode}
				operatorRatesButton={operatorRates}
				operatorBeautifulNumbersButton={operatorBeautifulNumbers}
				ratesMobileButton={ratesMobile}
				beautifulNumberButton={beautifulNumbers}
				operatorStyle={operatorStyle}
			/>
			{mobileTags &&
				mobileTags.map((tag) => (
					<TagButton
						key={tag.translit}
						elem={tag}
						active={tagCode === tag.translit}
						operatorRatesButton={operatorRates}
						operatorBeautifulNumbersButton={operatorBeautifulNumbers}
						unikalnye={tag.translit === "unikalnye"}
						operatorStyle={operatorStyle}
						ratesMobileButton={ratesMobile}
						beautifulNumberButton={beautifulNumbers}
					/>
				))}
			{!!providerInetMobile && (
				<TagButton elem={providerInetMobile} providerInetMobileButton={true} operatorStyle={true} />
			)}
			{!!providerInetTvMobile && (
				<TagButton
					elem={providerInetTvMobile}
					providerInetTvMobileButton={true}
					operatorStyle={true}
				/>
			)}
		</TagLayout>
	);
};

export default TagButtonComponent;
